module.exports = __webpack_public_path__ + "media/bootstrap-icons/pentagon-fill-7679aaa9.svg";